import { getUrlConfig } from './url.config';
import { IEnvironment } from './types';
import packageJson from '../../package.json';

const BASE_URL = 'https://europe-west1-pre-production-353905.cloudfunctions.net';
export const preProductionEnvironment: IEnvironment = {
  ...getUrlConfig(BASE_URL),
  GOOGLE_AUTH_SERVICE_ID: '335255622185-ge2m475ldshhhos1etlumv5j8mr32l1v.apps.googleusercontent.com',
  API_KEY: 'AIzaSyAJAaYzbt9c402pV69iw8ra3dYckiD5GBI',
  VIDEOCHAT_LINK: 'development-videochat.mindlyspace.com',
  AMPLITUDE_API_KEY: '27e96ef6fe0866477bca1ccc29bf28ea',
  REMOTE_CONFIG: {
    FETCH_INTERVAL_IN_SECONDS: 3600,
    DEFAULT_VALUES: {
      apple_pay_enabled: false,
      google_pay_enabled: false,
      is_supported_app_versions_feature_enabled: true,
      is_stream_chat_enabled: true,
      client_apps_flyer_one_link_enabled_specialists: '',
      client_apps_flyer_one_link_enabled_onboarding: '',
      is_nps_interview_enabled: true,
      is_nps_interview_new: true,
      SUPPORTED_APP_VERSIONS: JSON.stringify({
        [packageJson['api-version']]: {},
      }),
    },
  },
  INTERCOM: {
    APP_ID: 'isk9oqqt',
  },
  AGORA: {
    appID: '6fdcb7df6b8d447d8ecfca999ef6b7c8',
  },
  FIREBASE_CONFIG: {
    apiKey: 'AIzaSyCaLD-PIxK39wvH0GpYVTtspF68BYW8XnM',
    authDomain: import.meta.env?.VITE_AUTH_DOMAIN ?? 'pre-production-l9a21-app.mindlyspace.com',
    projectId: 'pre-production-353905',
    storageBucket: 'pre-production-353905.appspot.com',
    messagingSenderId: '335255622185',
    appId: '1:335255622185:web:720b8ff2d13a7f175c4238',
    measurementId: 'G-9CF8S46DS1',
  },
  STRIPE_PUBLIC_KEY:
    'pk_test_51IOrXcFWv7aoM10UtKaJoiPBfn9u9DTQmTE734xvsPSkrzh4osgXGo1JGdNWCjdVL1f7E5uaGtULCghICynqSu4F00IlV7jFqw',
  DEEP_LINK: 'https://mindlyspacedevelop.page.link/',
  APPS_FLYER_ONE_LINK: 'https://mindlyspace.onelink.me/SyFA',
  FB_PIXEL_ID: '858304681898657',
  TIK_TOK_PIXEL_ID: 'D07NN93C77U8J8QMNBN0',
  MAIN_WEB_URL: 'https://user-pre-prod.web.app',
  WEBSITE_URL: 'https://website-3.web.app',
  APPLE_PAY_MERCHANT_ID: 'merchant.com.mindly',
  STREAM_API_TOKEN: 'r6vsupw99p6c',

  JITSI_APP_ID: 'vpaas-magic-cookie-b157367e1efa48ceae44d6842caa9336',
};
